// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.search.dto.HpSearchScopeType

export enum HpSearchScopeType {
  ZILLOW_REGION = 'zillowRegion',
  ZILLOW_SCHOOL = 'zillowSchool',
  ZILLOW_SCHOOL_DISTRICT = 'zillowSchoolDistrict',
}

export const HpSearchScopeType_values = [
  HpSearchScopeType.ZILLOW_REGION,
  HpSearchScopeType.ZILLOW_SCHOOL,
  HpSearchScopeType.ZILLOW_SCHOOL_DISTRICT,
] as const;
